import type { ReactElement, ReactNode } from "react";

import { ModulesPending } from "./ModulesPending";
import { SectionUnavailable } from "./SectionUnavailable";
import { useEnabledModules } from "./useEnabledModules";
import type { ModuleName } from "./names";

export interface RequireModuleProps {
  /** Раздел открыт, если включён хотя бы один из модулей. */
  readonly anyOf: readonly ModuleName[];
  readonly children: ReactNode;
}

/**
 * Гейт раздела по составу модулей. «Раздела нет» — только после ответа,
 * в котором модуля нет; пока состав грузится или упал, показано
 * ожидание или ошибка с повтором (ADR-0083, п. 4).
 */
export function RequireModule({
  anyOf,
  children,
}: RequireModuleProps): ReactElement {
  const modules = useEnabledModules();
  if (modules.status !== "ready") {
    return <ModulesPending state={modules} />;
  }
  if (anyOf.some(modules.isEnabled)) {
    return <>{children}</>;
  }
  return <SectionUnavailable />;
}
